// extracted by mini-css-extract-plugin
module.exports = {"page":"index_page_-XyO8","header":"index_header_1jWMF"};